
import Vue from 'vue'
import marked from 'marked'
import ActivityImage from './ActivityImage.vue'
import ActivityExpanded from './ActivityExpanded.vue'
import ActivityDescription from './ActivityDescription.vue'
import ActionButtons from './ActionButtons.vue'
import { Portal } from 'portal-vue'
import {
  ProjectState,
  ProjectPath,
  ProjectActivity,
  URLParameterRange_ActivityType,
} from '../channel.types'
import { mapState, mapActions, mapGetters } from 'vuex'

const renderer = new marked.Renderer()

export default Vue.extend({
  props: {
    highlight_regex: RegExp,
    path: Object,
  },

  data() {
    return {
      default_thumbnail: require('../assets/thumbnail-default.png'),
      chevron_icon: require('../assets/chevron-down.svg'),
      expanded_activity_height: 0,
    }
  },

  methods: {
    triggerPlay() {
      const activityId = this.path.activity.id
      const rowId = this.path.row.id
      const channelSlug = this.$route.params.channelSlug
      const articleType = this.path.row.is_enabled_article_format
        ? URLParameterRange_ActivityType.ARTICLE
        : URLParameterRange_ActivityType.ACTIVITY
      const path = `/c/${channelSlug}/${rowId}/${articleType}/${activityId}/play`

      this.$router.push({ path })
    },

    triggerClick() {
      if (this.isEnabledSecondScreen) {
        this.triggerExpand()
      } else {
        this.triggerPlay()
      }
    },

    triggerExpand() {
      const activityId = this.path.activity.id
      const rowId = this.path.row.id
      const channelSlug = this.$route.params.channelSlug
      const articleType = this.path.row.is_enabled_article_format
        ? URLParameterRange_ActivityType.ARTICLE
        : URLParameterRange_ActivityType.ACTIVITY
      const path = `/c/${channelSlug}/${rowId}/${articleType}/${activityId}`

      this.$router.push({ path })
    },

    triggerCollapse() {
      const channelSlug = this.$route.params.channelSlug
      this.$router.push({ path: `/c/${channelSlug}` })
    },

    expandDidUpdate(height) {
      this.expanded_activity_height = height
    },

    highlight(text) {
      return this.highlight_regex
        ? text.replace(this.highlight_regex, match => `<b>${match}</b>`)
        : text
    },
  },
  computed: {
    ...mapState({
      description: state =>
        (<ProjectState>state).selection.activity.description,
      participant_id: state => (<ProjectState>state).participant_id,
    }),

    ...mapGetters({
      activity_url: 'fullActivityUrl',
      _isPathSelected: 'isPathSelected',
      _portalName: 'portalName',
      isSelectedPathAnArticle: 'isSelectedPathAnArticle',
    }),

    isEnabledSecondScreen() {
      return this.path.row.is_enabled_second_screen
    },
    isEnabledActivityClickthrough() {
      return this.path.row.is_enabled_activity_clickthrough
    },
    tileDesign() {
      return this.path.row.layout_class || 'landscape_description'
    },
    requiresDescription() {
      return this.tileDesign.indexOf('description') > -1
    },
    rowLayout() {
      return this.path.row.layout || 'carousel'
    },
    portalName() {
      return this._portalName(this.path)
    },

    activityExpandedKey() {
      const portalName = this.portalName
      const activityId = this.path.activity.activity_id
      return `${portalName}_${activityId}`
    },
    thumbnailUrl() {
      return this.path.activity.thumbnail_url
    },
    name() {
      return this.path.activity.name
    },
    synopsis() {
      return this.path.activity.synopsis
        ? marked(this.path.activity.synopsis, { renderer })
        : ''
    },

    isPathSelected: function() {
      return this._isPathSelected(this.path)
    },

    expandedActivityStyles() {
      const el = this.$refs.el as HTMLDivElement

      //TODO. Sort this out. because of the dynamic routes, this will sometimes be null. The component will
      //be destroyed, but this function will get called.
      if (!el) {
        return {}
      }

      return this.rowLayout === 'flow'
        ? {
            top: `${el.offsetTop + el.offsetHeight + 20}px`,
          }
        : {}
    },

    style() {
      return this.rowLayout === 'flow' && this.expanded_activity_height
        ? { marginBottom: `${this.expanded_activity_height}px` }
        : {}
    },
  },

  components: {
    ActivityImage,
    ActivityExpanded,
    ActivityDescription,
    ActionButtons,
  },
})
